import { ReactNode } from 'react';
import cn from 'classnames';

import './tipster.scss';

const classNameSuffixes = {
  information: 'info',
  success: 'success',
  warning: 'warning',
  error: 'danger',
  help: 'help',
};

const icons = {
  information: 'information-outline',
  success: 'checkbox-marked-circle-outline',
  warning: 'alert-circle',
  error: 'alert-circle',
  help: 'help-circle',
};

type TipsterProps = {
  className?: string;
  info?: string | ReactNode;
  type?: 'information' | 'success' | 'warning' | 'error' | 'help';
  iconTop?: boolean;
  icon?: string;
  compact?: boolean;
  children?: ReactNode;
};

const Tipster = ({
  className,
  info = '',
  type = 'information',
  icon = '',
  iconTop,
  compact = false,
  children = null,
}: TipsterProps) => {
  const iconName = icon || icons[type];
  const suffix = classNameSuffixes[type];

  if (!info && !children) {
    return null;
  }

  return (
    <div
      className={cn({
        Tipster: true,
        'Tipster--iconTop': iconTop,
        [`Tipster--${suffix}`]: !!suffix,
        'Tipster--compact': !!compact,
        ...(className && { [className]: true }),
      })}
    >
      {iconName && <i className={`Tipster__icon mdi mdi-${iconName}`} />}
      <div className="Tipster__text">{info || children}</div>
    </div>
  );
};

export { Tipster };
export type { TipsterProps };
